// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"101":"37541ce7","585":"714ca43d"}[chunkId] || chunkId) + "." + {"101":"4d9aac423be0de74","387":"a2d1e381b8a62e83","545":"b5f22bb6d40e5152","585":"37a19f583700f530"}[chunkId] + ".js";
};